export const TABLE_LABELS: { [table: string]: string } = {
  invoices: "Devis et factures",
  contacts: "Contacts",
  articles: "Articles",
  crm_items: "Opportunités CRM",
  service_items: "Tâches",
  service_times: "Temps passés",
  stock_items: "Éléments de stock",
  accounting_transactions: "Transactions comptables",
  comments: "Commentaires",
  files: "Fichiers",
};

export const INVOICE_TYPE_LABELS: { [type: string]: string } = {
  quotes: "Devis",
  invoices: "Factures",
  credit_notes: "Avoirs",
  supplier_quotes: "Commandes fournisseurs",
  supplier_invoices: "Factures fournisseurs",
  supplier_credit_notes: "Avoirs fournisseurs",
};
